import React, {useState, useEffect} from "react";
import {request} from 'utils.js'
import {Link} from "react-router-dom";
import moment from 'moment';

import "./index.less";

const NoticeListRow = (props) => {
	let {id, title,content, pushTime, tName} = props;
	return (
		<div className="lawNewList">
			<Link className="name" to={`/newsDetail/${id}/${tName}`}>
				<div className="newsTime">
					<span>{moment(new Date(pushTime)).format("DD")}</span>
					<span>{moment(new Date(pushTime)).format("YYYY-MM")}</span>
				</div>
				<div className="newsTextBox">
					<h3>{title}</h3>
					<p dangerouslySetInnerHTML={{
						__html: content,
					}}></p>
				</div>
			</Link>
		</div>
		
	);
};
export default function News(props) {
	const initData = {
		id: '1910196789738733570', name:'政策法规'
	}
	const {id: isType} = props
	const [newList, setNewsList] = useState([])
	const [pageInfo, setPage] = useState({
		current: 1,
		pageSize: 8,
		isType: '',
		dCategory: '', // 类别
		dType: '', // 类型
	})
	useEffect(() => {
		// 列表记录
		request({
			method: 'post',
			url: '/aiprt-common-notice-be/pltdynamic/lists',
			data: {
				...pageInfo,
				previewCnt:"Y",
				isType: '1910196789738733570'
			}
		}).then(res => {
			setNewsList(res.list)
		});
	}, [isType]);
	
	return (
		<>
			<div className="lawBox">
				<div className="lawBox-title">
					<h3>政策法规</h3>
					<Link to={`/news/${initData.id}/${initData.name}`} className="notice-more">{'查看更多 >> '}</Link>
				</div>
				<div className="lawBox-content">
					{newList?.map((item, index) => {
						return (
							<NoticeListRow
								key={item.id}
								id={item.id}
								title={item.title}
								content={item.content}
								isTop={item.isTop}
								tName={initData.name}
								pushTime={item.pushTime}
								isType={item.isType}
								dTypeText={item.dTypeText}
								dCategoryText={item.dCategoryText}
							/>
						);
					})}
				</div>
			</div>
		</>
	);
}
